$(document).ready(function () {
    String.prototype.format = function () {
        var s = this, i = arguments.length;
        while (i--)
            s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);

        return s;
    };

	var getQueryString = function (name) {
		// This function apparently came from here
		// https://davidwalsh.name/query-string-javascript
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
		results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	};
    window["application"] = {
        initialize: function($el) {
            this.$el = $el;

            this.Urls = {
                VehicleYearsUrl: "DDHandler.lmxd?a=getyears",
                VehicleMakeUrl: "DDHandler.lmxd?a=getmakes",
                VehicleModelUrl: "DDHandler.lmxd?a=getmodels",
                VehicleStyleUrl: "DDHandler.lmxd?a=getstyles",
                PaymentQuoteUrl: "DDHandler.lmxd?a=getquickquote",
                StatesUrl: "DDHandler.lmxd?a=getstates",
                SblStipulationA: "DDHandler.lmxd?a=GetSblStipulations&type=ProofOfBusinessA",
                SblStipulationB: "DDHandler.lmxd?a=GetSblStipulations&type=ProofOfBusinessB1",
                LoanTypeUrl: "DDHandler.lmxd?a=getloantypes",
                BusinessIndustryTypes: "DDHandler.lmxd?a=getbusinesscategorytypes",
                StateMinimumAmount: "DDHandler.lmxd?a=getminimumproceeds",
                LoanStateUrl: "DDHandler.lmxd?a=getloanstates",
                BusinessHours: "DDHandler.lmxd?a=getbusinesshours",
                TokenLoanUrl: "DDHandler.lmxd?a=gettokenloan",
                GetExternalLoanUrl: "DDHandler.lmxd?a=getexternalloan",
                GetTurnedDownPulLoan: "DDHandler.lmxd?a=getturneddownpulloan",
                GetLeadSaleDestinationInfo: "DDHandler.lmxd?a=getleadsaledestinationinfo",
                SaveLeadSaleLoanLead: "DDHandler.lmxd?a=saveleadsaleloanlead"
            };
			for(url in this.Urls) {
				//append domain name to path to allow for ease of changing/repointing
				this.Urls[url] = globalSiteSettings.ddHandlerUrl + this.Urls[url];
			}
        },
        SaveApplication: function(additionData) {
            var dfd = new $.Deferred();

            var data = this.$el.serializeArray(),
                action = globalSiteSettings.ddHandlerUrl + "AppHandler.lmxd",
                method = "post";

            if (additionData) {
                $.each(additionData, function(index, item) {
                    data.push(item);
                });
            }            
            data.push({ name: 'loantype', value: application.LoanType });
            data.push({ name: 'source', value: getQueryString("source") });
            data.push({ name: 'sourceLocation', value: getQueryString("sourceLocation") });
            data.push({ name: 'sourceType', value: getQueryString("sourceType") });

            $.ajax({
                url: action,
                type: method,
                data: data,
                success: function(data) {
                    dfd.resolve(data);
                },
                error: function(xhr, textStatus, error) {
                    dfd.reject(xhr, textStatus, error);
                }
            });

            return dfd.promise();
        },
        GetJsonAjax: function(url, data) {
            var dfd = new $.Deferred();

            $.ajax({
                type: "GET",
                url: url,
                data: data,
                dataType: 'json',
                success: function(data) {
                    dfd.resolve(data);
                },
                error: function(err) {
                    dfd.reject(err);
                }
            });

            return dfd.promise();
        },
        GetVehicleYears: function() {
            return this.GetJsonAjax(this.Urls.VehicleYearsUrl, {});
        },
        GetVehicleMakes: function(vehicleYear) {
            return this.GetJsonAjax(this.Urls.VehicleMakeUrl, { yearname: vehicleYear });
        },
        GetVehicleModels: function(vehicleYear, vehicleMake) {
            var data = { yearname: vehicleYear, makename: vehicleMake };
            return this.GetJsonAjax(this.Urls.VehicleModelUrl, data);
        },
        GetVehicleStyles: function(vehicleYear, vehicleMake, vehicleModel) {
            var data = { yearname: vehicleYear, makename: vehicleMake, modelname: vehicleModel };
            return this.GetJsonAjax(this.Urls.VehicleStyleUrl, data);
        },
        GetQuickQuote: function(vehicleYear, vehicleMake, vehicleModel, vehicleStyle, mileage, state) {
            var dfd = new $.Deferred();

            var data = {
                yearId: "",
                year: vehicleYear,
                makeid: "",
                make: vehicleMake,
                modelid: "",
                model: vehicleModel,
                styleid: "",
                style: vehicleStyle,
                state: state,
                mileage: mileage
            };

            if (application.LoanType !== 'Unknown')
                data.loanType = application.LoanType;

            this.GetJsonAjax(this.Urls.PaymentQuoteUrl, data)
                .done(function(results) {
                    var result = results[0];

                    if (typeof (result['DefaultAmount']) == "undefined")
                        dfd.reject(result['Name']);
                    else
                        dfd.resolve(results);
                });

            return dfd.promise();
        },
        GetStates: function() {
            return this.GetJsonAjax(this.Urls.StatesUrl, {});
        },
        SetLoanType: function(state) {
            var dfd = $.Deferred();

            this.GetJsonAjax(this.Urls.LoanTypeUrl, { state: state })
                .done(function(arr) {
                    var aelApp = false;
                    var sblApp = false;

                    $.each(arr, function(index, item) {
                        aelApp = item.Value === 'Ael';
                        sblApp = item.Value === 'Sbl';
                    });

                    if (aelApp) {
                        application.LoanType = 'Ael';
                        dfd.resolve('Ael');
                    } else if (sblApp) {
                        application.LoanType = 'Sbl';
                        dfd.resolve('Sbl');
                    } else {
                        application.LoanType = 'Unknown';
                        dfd.resolve('Unknown');
                    }
                })
                .fail(function(response) {
                    dfd.reject(response);
                });


            return dfd.promise();

        },
        GetSblStipulationsA: function() {
            return this.GetJsonAjax(this.Urls.SblStipulationA);
        },
        GetSblStipulationsB: function() {
            return this.GetJsonAjax(this.Urls.SblStipulationB);
        },
        GetBusinessIndustryTypes: function() {
            return this.GetJsonAjax(this.Urls.BusinessIndustryTypes);
        },
        GetStateMinimumAmount: function(loanType, state) {
            var data = { loantype: loanType, state: state };
            return this.GetJsonAjax(this.Urls.StateMinimumAmount, data);
        },
        GetLoanStates: function(loanType) {
            var data = { loanType: loanType }
            return this.GetJsonAjax(this.Urls.LoanStateUrl, data);
        },
        GetBusinessHours: function() {
            return this.GetJsonAjax(this.Urls.BusinessHours, {});
        },

        GetTokenLoan: function() {
            var token = getQueryString('token');

            if (token !== '')
                return this.GetJsonAjax(this.Urls.TokenLoanUrl, { token: token });
            else {
                var dfd = new $.Deferred();
                setTimeout(function() {
                    dfd.resolve(undefined);
                }, 100);
                return dfd.promise();
            }
        },

        GetExternalLoan: function(queryStringKey) {
            if (!queryStringKey) {
                queryStringKey = 'key' //external key
            }

            var key = getQueryString(queryStringKey);
            var partner = getQueryString('p');
            if (key && partner) {
                return this.GetJsonAjax(this.Urls.GetExternalLoanUrl, { key: key, p: partner })
            } else {
                var dfd = new $.Deferred();
                setTimeout(function() {
                    dfd.resolve(undefined);
                }, 100);
                return dfd.promise();
            }
        },
        
        IsTurnedDownPulRedirect: function() {
            var token = getQueryString("token");
            return document.referrer !== "" && document.referrer.indexOf("personal-loans/no-personal-loan-offer.asp") >= 0 && !token;
        },

        GetTurnedDownPulLoan: function () {
            return this.GetJsonAjax(this.Urls.GetTurnedDownPulLoan);
        },

        GetApplicationPhoneNumber: function() {
            var appPhoneNumber = getQueryString("phone");

            if (appPhoneNumber !== "") {
                return appPhoneNumber;
            }
            else {
                return "";
            }
        },
        GetLeadSaleDestinationInfo: function (state, loanType) {
            return this.GetJsonAjax(this.Urls.GetLeadSaleDestinationInfo, { state: state, loanType: loanType });
        },
        SaveLeadSaleLoanLead: function (firstName, lastName, email, state) {
            var dfd = new $.Deferred();

            var data = {firstName: firstName, lastName: lastName, email: email, state: state},
                action = this.Urls.SaveLeadSaleLoanLead,
                method = "POST";

            $.ajax({
                url: action,
                type: method,
                data: data,
                success: function (data) {
                    dfd.resolve(data);
                },
                error: function (xhr, textStatus, error) {
                    dfd.reject(xhr, textStatus, error);
                }
            });

            return dfd.promise();
        }
    };
});
